import * as React from "react";
import {css, cx} from "emotion";

import "./sub-cats.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {MenuInternalLink} from "../../../../../common/components/internal-link";
import {ObserveSize}      from "../../../../../common/components/observe-size";

export const SubCats = ({catId, subCatList, navBlock}) => cs(
    consumeContext("themeScheme"),
    ["size", (_, next) => <ObserveSize {...{next}}/>],
    ({size, themeScheme}) => {
        const colWidth = 240;
        if (!size) {
            return <div className="sub-cats-93kjd"/>;
        }

        const {width, height} = size;
        const subCatHeight = 40;
        const tilesPerCol = Math.floor(height / subCatHeight);
        const colsCount = Math.floor(width / colWidth);
        const maxCount = tilesPerCol * colsCount;

        return (
            <div
                className="sub-cats-93kjd"
            >

                {subCatList.slice(0, maxCount-1).map((style) => (
                    MenuInternalLink({
                        to: `/cat/${catId}/sub/${style.id}`,
                        className: cx("sub-cat", css`
                            color: ${themeScheme.xpresso.menuTextColor} !important;
                        `),
                        key: style.id,
                        style: {
                            width: colWidth,
                            lineHeight: subCatHeight + "px",
                        },
                        "data-tip": style.name,
                        "xd-qa-type": "link",
                        "xd-qa-name": style.name,
                        navBlock,
                        children: style.name,
                    })
                ))}

                {subCatList.length >= maxCount && (
                    MenuInternalLink({
                        to: `/cat/${catId}`,
                        className: cx("sub-cat view-more", css`
                            color: ${themeScheme.xpresso.menuTextColor} !important;
                        `),
                        key: "view-more",
                        style: {
                            width: colWidth,
                            lineHeight: subCatHeight + "px",
                        },
                        "data-tip": "view-more",
                        "xd-qa-type": "link",
                        "xd-qa-name": "View more",
                        navBlock,
                        children: <>
                            View more {" "}
                            <i className="fa fa-angle-double-right"/>
                        </>,
                    })
                )}
            </div>
        );
    }
);
